module.exports = __webpack_public_path__ + "img/girl.15358f50.png";